import { BusinessEnvironment } from '@/app/enums';
import { HTTPQuery, ResponseError } from '@/app/api';
import { isServer } from '@/app/utils/isServer';

export const constructAccessToken = (token: string) => `Bearer ${token}`;

export const querystring = (params: HTTPQuery, prefix: string = ''): string => {
  return Object.keys(params)
    .map((key) => querystringSingleKey(key, params[key], prefix))
    .filter((part) => part.length > 0)
    .join('&');
};

const querystringSingleKey = (
  key: string,
  value:
    | string
    | number
    | null
    | undefined
    | boolean
    | Array<string | number | null | boolean>
    | Set<string | number | null | boolean>
    | HTTPQuery,
  keyPrefix: string = '',
): string => {
  if (value === null || value === undefined) {
    return '';
  }

  const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);

  if (value instanceof Array) {
    const multiValue = value
      .map((singleValue) => encodeURIComponent(String(singleValue)))
      .join(`&${encodeURIComponent(fullKey)}[]=`);
    return `${encodeURIComponent(fullKey)}[]=${multiValue}`;
  }
  if (value instanceof Set) {
    const valueAsArray = Array.from(value);
    return querystringSingleKey(key, valueAsArray, keyPrefix);
  }
  if (value instanceof Date) {
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
  }
  if (value instanceof Object) {
    return querystring(value as HTTPQuery, fullKey);
  }
  return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
};

export const getBaseApiURL = () => {
  if (process.env.NEXT_PUBLIC_BUSINESS_ENV === BusinessEnvironment.LOCAL && typeof window !== 'undefined') {
    return process.env.NEXT_PUBLIC_BASE_URL;
  }

  return process.env.NEXT_PUBLIC_API_BASE_URL;
};

// That's for routing in docker
export const resolveNextApiUrl = () => {
  return isServer() ? process.env.NEXT_PUBLIC_BASE_URL : '';
};

export const isResponseError = (error: unknown): error is ResponseError => !!(error as any)?.response?.status;
